import { StatsTheme } from '../types'
import { base } from './base'

import bgGradient from '../assets/bg/stats-theme-bg-dark-pink.webp'
import upsell from '../assets/upsell/fable-plus-upsell-charts-dark-pink.webp'
import { theme } from '@fable/theme'

export const darkPink: StatsTheme = {
  id: 'dark_pink',
  name: 'Dark Pink',
  colors: {
    base,
    menuDot: '#9B5771',
    primary: '#E882AA',
    secondary: base.jungle,
    bg: '#05120E',
    bgGradient,
    hero: {
      iconColor: '#042119',
      shareTextColor: '#082D23',
    },
    section: {
      bg: '#082D23',
      bgSecondary: '#042119',
      text: theme.colors.uiWhite,
      textSecondary: theme.colors.uiWhite50,
      textReadingGoal: theme.colors.uiWhite,
      tabBg: '#042119',
      tabBtnBg: theme.colors.uiWhite,
      tabBtnText: {
        idle: theme.colors.uiWhite,
        active: theme.colors.uiGraphite,
      },
      shareBg: '#042119',
      shareText: theme.colors.uiWhite,
      chart: { ghost: '#042119', lines: theme.colors.uiWhite20 },
      legend: { text: theme.colors.uiWhite70 },
    },
    goals: {
      petalEmpty: '#FFFFFF33',
    },
    charts: {
      genresPie: ['#FFDAF5', '#FA6113', '#F197CD', '#006FEA', '#E882AA'],
      genreStream: ['#FFC3D2', '#526C03', '#32500D', '#F197CD', '#4F8111'],
      streakMap: {
        default: '#042119',
        bestStreak: '#FA6113',
        daysRead: '#F3A6DD',
        finished: '#006FEA',
      },
      momStreaks: {
        cellBg: theme.colors.uiBlack40,
        bestStreak: { bg: '#E882AA', text: '#06120E' },
        daysRead: { bg: theme.colors.uiWhite20, text: '#042119' },
        noReading: {
          current: {
            bg: 'transparent',
            text: theme.colors.uiWhite20,
            border: 'transparent',
          },
          other: {
            bg: 'transparent',
            text: theme.colors.uiBlack60,
            border: theme.colors.uiBlack40,
          },
        },
      },
    },
    blurs: {
      section: {
        top: 'rgba(255, 195, 210, 0.5)',
        middle: 'rgba(255, 195, 210, 1)',
        bottom: 'rgba(252, 249, 245, 0.8)',
        topAlt: 'rgba(110, 119, 115, 0.8)',
        bg: { start: 'rgba(171, 151, 155, 1)' },
      },
      sectionAlt: {
        top: 'rgba(255, 195, 210, 0.3)',
        middle: 'rgba(255, 195, 210, 1)',
        bg: { start: 'rgba(196, 184, 185, 1)' },
      },
    },
    upsell,
    upsellBtnBg: '#FA6113',
    upsellBtnText: theme.colors.uiWhite,
  },
}
